<template>
  <div class="content">
    <div class="admin-content">
      <div class="content-c">
        <el-form :model="pararms" ref="queryForm" :inline="true">
          <el-form-item label="办理时间">
            <el-date-picker v-model="dateRange" size="small" style="width: 240px" value-format="yyyy-MM-dd"
              type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="请输入网点号">
            <el-input v-model="pararms.fname" placeholder="请输入网点号" clearable size="small"
              @keyup.enter.native="handleQuery" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>
        <el-form>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="goTongji">查看使用明细</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="recordList" border stripe style="width: 100%" @row-click="chooseTab">
          <el-table-column prop="fip" label="IP地址">
          </el-table-column>
          <el-table-column prop="fname" label="网点号">
          </el-table-column>
          <el-table-column prop="fcount" label="数量">
          </el-table-column>
        </el-table>
        <!-- <pagination v-show="total > 0" :total="total" :page.sync="pararms.pageNum" :limit.sync="pararms.pageSize"
          @pagination="getList" /> -->
      </div>
      <div style="width: 100%; height: 35rem"></div>
    </div>
    <Back />
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      pararms: {
        // pageNum: 1,
        // pageSize: 10,
        fname: null,
        bdate: null,
        edate: null
      },
      total: 0,
      recordList: [],
      dateRange: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    chooseTab(e) {
      console.log(e);
      this.$router.push({
        path: '/record',
        query: {
          fip: e.fip,
          fname: e.fname
        }
      })
    },
    getList() {
      if (this.dateRange.length) {
        this.pararms.bdate = this.dateRange[0]
        this.pararms.edate = this.dateRange[1]
      }
      this.$rqt.PrintInfo_count(this.pararms).then(res => {
        console.log(res);
        this.recordList = res.rows
        this.total = res.total;
      })
    },
    handleQuery() {
      this.pararms.pageNum = 1;
      this.getList();
    },
    resetQuery() {
      this.dateRange = []
      this.pararms = {
        // pageNum: 1,
        // pageSize: 10,
        fname: null,
      }
      this.getList();
      // this.handleQuery()
    },
    // typeFormat(row) {
    //   return this.$fun.getTime(row.fprinttime)
    // },
    goTongji() {
      this.$router.replace('/record')

    }
  }
};
</script>
<style scoped lang="scss">
.content {
  // padding: 0 10%;
  font-size: 6rem;
}

.admin-content {
  width: 100%;
  min-height: 100vh;
  background-color: #fff;

  .content-c {
    padding-top: 20px;
    width: 95%;
    margin: auto;
  }
}
</style>